import { inject, Injectable } from '@angular/core';
import { combineQueries, Order, QueryConfig, QueryEntity } from '@datorama/akita';
import { map } from 'rxjs/operators';

import { CommonConstants } from '@shared/constants/common.constants';
import { PatientProtocolType } from '@shared/services/gql.service';
import { PaymentSchedulesQuery } from '@shared/store/payment-schedules/payment-schedules.query';

import { PatientProtocolState, PatientProtocolStore } from './patient-protocol.store';

@Injectable({ providedIn: 'root' })
@QueryConfig({
  sortBy: 'order_by',
  sortByOrder: Order.ASC,
})
export class PatientProtocolQuery extends QueryEntity<PatientProtocolState> {
  private paymentSchedulesQuery = inject(PaymentSchedulesQuery);

  protected store: PatientProtocolStore;

  private commonConstants = CommonConstants;

  constructor() {
    const store = inject(PatientProtocolStore);

    super(store);

    this.store = store;
  }

  getPatientProtocolsBasedOnType(
    types: PatientProtocolType[],
    site_id: string,
    patient_group_id?: string
  ) {
    return combineQueries([
      this.selectAll({
        filterBy: (entity) => types.includes(entity.patient_protocol_type),
      }),
      this.paymentSchedulesQuery.selectAll({
        filterBy: (paymentSchedule) => paymentSchedule.site_id === site_id,
      }),
    ]).pipe(
      map(([patientProtocols, paymentSchedules]) => {
        const filterPaymentSchedules = (patient_protocol_id: string) =>
          paymentSchedules.filter(
            (paymentSchedule) => paymentSchedule.patient_protocol_id === patient_protocol_id
          );

        return (
          patient_group_id
            ? patientProtocols.filter((protocol) => {
                return patient_group_id === this.commonConstants.PATIENT_VISITS_GROUP_ID
                  ? protocol.__typename !== 'PatientVisit' || !protocol.patient_group_id
                  : protocol.__typename === 'PatientVisit' &&
                      protocol.patient_group_id === patient_group_id;
              })
            : patientProtocols
        ).map((patientProtocol) => {
          const paymentSchedule = filterPaymentSchedules(patientProtocol.id)?.[0];

          return {
            ...patientProtocol,
            amount: paymentSchedule?.amount,
            note: paymentSchedule?.note,
            paymentScheduleId: paymentSchedule?.id,
          };
        });
      })
    );
  }
}
